import axios from "axios";
import { BASE_URL } from "./url";
import { withCache, invalidateCache } from "../utils/apiCache";

const mApi = axios.create({
    withCredentials: true,
    baseURL: BASE_URL,
});

export const getGroups = async () =>
    withCache("groups/all", async () => {
        try {
            const result = await mApi.get("/groups");
            return result?.data;
        } catch (e) {
            console.log(e);
            return { ok: false, ...e?.response?.data };
        }
    });

export const getGroup = async (id) =>
    withCache(`groups/${id}`, async () => {
        try {
            const result = await mApi.get(`/groups/${id}`);
            return result?.data;
        } catch (e) {
            console.log(e);
            return { ok: false, ...e?.response?.data };
        }
    });

export const addGroup = async (group) => {
    try {
        const result = await mApi.post("/groups", group);
        invalidateCache("groups/all");
        return result?.data;
    } catch (e) {
        console.log(e);
        return { ok: false, ...e?.response?.data };
    }
};
